import { price } from '@/mixins/price'
import { durationUnit } from '@/mixins/durationUnit'

const joinTariffExtra = function (tariff, tariffExtras = null) {
  const tariffExtra = tariffExtras?.find(extra => {
    return (extra.id === tariff.tariffId)
  })
  return {
    ...tariff,
    tariffExtra: tariffExtra,
    formattedBasicFee: price(tariff.basicFee || 0),
    formattedUnit: durationUnit(tariff.runtime.unit.toUpperCase(), tariff.runtime.amount)
  }
}

export default joinTariffExtra
